import type { EffectCallback } from 'react'

import _ from 'lodash'
import { useRef, useEffect } from 'react'

export const useDeepEffect = (
  callback: EffectCallback,
  dependency: unknown[],
) => {
  const isArrayDeepEqual = (x: unknown[], y: unknown[]) => {
    if (x.length !== y.length) return false
    return _(x).differenceWith(y, _.isEqual).isEmpty()
  }

  const useDeepComparison = (dep: unknown[]) => {
    const ref = useRef<unknown[]>([])
    if (!isArrayDeepEqual(ref.current, dep) || !ref.current.length) {
      ref.current = dep
    }
    return ref.current
  }

  useEffect(callback, useDeepComparison(dependency))
}
